import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["alerts", "onClose", "ofText", "classes", "hideCloseButton", "namespace", "align", "onShow"];
import React, { forwardRef, useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import classNames from 'classnames/bind';
import { defaultPropArray, defaultPropObject } from "../constants";
import { useSwipe } from "../hooks/useSwipe";
import { deprecate } from "../utils/deprecate";
import { getMethodsForTestId } from "../utils/getMethodsForTestId";
import noop from "../utils/noop";
import { TechnicalMessageAlert, TechnicalMessageDot, TechnicalMessageDotPanel } from './components';
import { views } from './constants';
import { useTechnicalMessage } from './useTechnicalMessage';
import styles from './TechnicalMessage.css';
var cx = classNames.bind(styles);
var deprecation = deprecate('свойство hideCloseButton будет удалено с версии 3.0.0, для отключения кнопки закрыть указывайте hideCloseButton в объекте конкретного алерта', 'TechnicalMessage');
var TechnicalMessage = /*#__PURE__*/forwardRef(function TechnicalMessage(_ref, ref) {
  var _ref$alerts = _ref.alerts,
      alerts = _ref$alerts === void 0 ? defaultPropArray : _ref$alerts,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? noop : _ref$onClose,
      _ref$ofText = _ref.ofText,
      ofText = _ref$ofText === void 0 ? 'из' : _ref$ofText,
      _ref$classes = _ref.classes,
      classes = _ref$classes === void 0 ? defaultPropObject : _ref$classes,
      _ref$hideCloseButton = _ref.hideCloseButton,
      hideCloseButtonAll = _ref$hideCloseButton === void 0 ? false : _ref$hideCloseButton,
      namespace = _ref.namespace,
      align = _ref.align,
      _ref$onShow = _ref.onShow,
      onShow = _ref$onShow === void 0 ? noop : _ref$onShow,
      rest = _objectWithoutProperties(_ref, _excluded);

  var refContent = useRef(ref);

  var _useTechnicalMessage = useTechnicalMessage({
    alerts: alerts,
    onClose: onClose,
    onShow: onShow
  }),
      handleShow = _useTechnicalMessage.handleShow,
      handleClose = _useTechnicalMessage.handleClose,
      handleNext = _useTechnicalMessage.handleNext,
      handlePrev = _useTechnicalMessage.handlePrev,
      handleSwipe = _useTechnicalMessage.handleSwipe,
      currentAlert = _useTechnicalMessage.currentAlert,
      visibleAlerts = _useTechnicalMessage.visibleAlerts;

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'technicalMessage'),
      getTestId = _getMethodsForTestId.getTestId,
      getNamespace = _getMethodsForTestId.getNamespace;

  useSwipe({
    ref: refContent,
    callback: handleSwipe
  });
  deprecation();
  return /*#__PURE__*/React.createElement(CSSTransition, {
    in: Boolean(visibleAlerts.length),
    unmountOnExit: true,
    timeout: 200
  }, /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    ref: refContent,
    className: cx('root', classes.root)
  }, getTestId()), visibleAlerts.map(function (_ref2, idx) {
    var id = _ref2.id,
        type = _ref2.type,
        content = _ref2.content,
        hideCloseButton = _ref2.hideCloseButton;
    var counterText = "".concat(idx + 1, " ").concat(ofText, " ").concat(visibleAlerts.length);
    var view = visibleAlerts.length > 1 ? views.flipping : views.single;
    return /*#__PURE__*/React.createElement(TechnicalMessageAlert, {
      key: id,
      type: type,
      onClose: !hideCloseButtonAll ? function () {
        return handleClose(id);
      } : undefined,
      hideCloseButton: hideCloseButton,
      onNext: function onNext() {
        return handleNext(id);
      },
      onPrev: function onPrev() {
        return handlePrev(id);
      },
      onShow: function onShow() {
        return handleShow(id);
      },
      visible: id === currentAlert.id,
      disabledNext: visibleAlerts.length - 1 === idx,
      disabledPrev: idx === 0,
      view: view,
      counterText: counterText,
      namespace: getNamespace(idx.toString()),
      align: align
    }, content);
  }), visibleAlerts.length > 1 && /*#__PURE__*/React.createElement("div", {
    className: cx('dots')
  }, /*#__PURE__*/React.createElement(TechnicalMessageDotPanel, null, visibleAlerts.map(function (_ref3) {
    var id = _ref3.id;
    return /*#__PURE__*/React.createElement(TechnicalMessageDot, {
      key: id,
      active: id === currentAlert.id
    });
  })))));
});
export default TechnicalMessage;